import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 22C14.3789 22 16.2156 21.4428 17.7779 20.399C19.3402 19.3551 20.5578 17.8714 21.2769 16.1355C21.9959 14.3996 22.184 12.4895 21.8175 10.6466C21.4509 8.80382 20.5461 7.11109 19.2175 5.78249C17.8889 4.45389 16.1962 3.5491 14.3534 3.18254C12.5105 2.81598 10.6004 3.00411 8.86451 3.72314C7.12861 4.44218 5.64491 5.65981 4.60104 7.22208C3.55717 8.78435 3 10.6211 3 12.5",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3 12C3 13.3132 3.25866 14.6136 3.7612 15.8268C4.26375 17.0401 5.00035 18.1425 5.92893 19.0711C6.85752 19.9997 7.95991 20.7362 9.17317 21.2388C10.3864 21.7413 11.6868 22 13 22",
  stroke: "currentColor",
  "stroke-dasharray": "2 2"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.05627 12.7609L11.2279 16.0451L15.8775 9.06033",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }